module.exports = __webpack_public_path__ + "assets/96e34f03a83a18095e224fd2d34c44dc.png";